'use strict';
/**
 * @author Maxim Seredkin
 */
export default function projectPlanFundTable() {
    return {
        restrict: 'A',
        template: require('../../../../../../../view/table.html'),
        transclude: false,
        scope: {
            selectedItem: '=?myValue',
            items: '=?myItems',
            type: '@myType',
            filters: '=?myFilters',
            ok: '=?myOk',
            isPaging: '=myPagination',
            isSearch: '=mySearching',
            isFilter: '=myFilter',
            project: '=myProject',
            edit: '=edit',
            hideNotEdit: '=hideNotEdit',
            changed: '=?myChanged',
        },
        controller: ['$scope', '$routeParams', '$utils', '$uibModal',
                     function($scope, $routeParams, $utils, $modal) {
                         if (!$scope.selectedItem) {
                             $scope.selectedItem = {};
                         }

                         $scope.columns = [
                        //      {
                        //     name: "Год",
                        //     data: "quarter.year"
                        // }, {
                        //     name: "Квартал",
                        //     data: "quarter.quarterNumber"
                        // },
                        {
                             name: 'Категория источника',
                             data: 'srcCategory.name',
                         }, {
                             name: 'Наименование источника',
                             data: 'name',
                         }, {
                             name: 'Страна',
                             data: 'country.name',
                         }, {
                             name: 'Сумма',
                             data: 'amount',
                         }, {
                             name: 'Документ',
                             data: 'attachments',
                             type: 'attachments',
                         }];

                         $scope.searching = {
                             isSearch: $scope.isSearch,
                             filter: null,
                         };

                         $scope.pagination = {
                             isPaging: $scope.isPaging,
                             page: 1,
                             size: $scope.isPaging ? 10 : null,
                             totalPages: null,
                             totalItems: null,
                         };

                         ($scope.refresh = function() {
                             if (Array.isArray($scope.items)) {
                                 if ($scope.items.every((i) => !equals(i, data))) {
                                     $scope.selectedItem = {};
                                 }
                             }
                         })();

                         $scope.toolbox = {
                             buttons: {
                                 create: {
                                     show: () => $scope.edit,
                                     click: () => {
                                         $modal.open({
                                            template: require('../view/project-plan-fund-modal-create.html'),
                                            controller: 'ProjectPlanFundModalCreateController',
                                            size: 'lg',
                                            backdrop: false,
                                            resolve: {
                                                planFund: function() {
                                                    return {};
                                                },
                                                edit: function() {
                                                    return $scope.edit;
                                                },
                                            },
                                        }).result.then(function(data) {
                                             if (!$scope.items.some((item) => equals(item, data))) {
                                                 $scope.items.push(data);
                                             }
                                         });
                                     },
                                     disabled: () => false,
                                 },
                                 edit: {
                                     show: () => true,
                                     click: (item) => {
                                         $modal.open({
                                            template: require('../view/project-plan-fund-modal-create.html'),
                                            controller: 'ProjectPlanFundModalCreateController',
                                            size: $scope.edit ? 'lg' : 'md',
                                            backdrop: false,
                                            resolve: {
                                                planFund: function() {
                                                    return item;
                                                },
                                                edit: function() {
                                                    return $scope.edit;
                                                },
                                            },
                                        }).result.then(function(data) {
                                             angular.copy(data, item);
                                             angular.copy(data, $scope.selectedItem);
                                         });
                                     },
                                     disabled: () => !isSelected(),
                                 },
                                 remove: {
                                     show: () => $scope.edit,
                                     click: (item) => {
                                         $scope.items.splice($scope.items.indexOf($scope.items.find((it) => equals(it, item))), 1);
                                         angular.copy({}, $scope.selectedItem);
                                     },
                                     disabled: () => !isSelected(),
                                 },
                                 refresh: {
                                     show: () => false,
                                     click: $scope.refresh,
                                     disabled: () => false,
                                 },
                             },
                         };

                         $scope.dblClick = function(item) {
                             switch ($scope.type) {
                                 case 'table':
                                     $scope.toolbox.buttons.edit.click(item);
                                     break;
                                 case 'select':
                                     $scope.ok();
                                     break;
                             }
                         };

                         $scope.select = function(item) {
                             if (!$scope.isSelect(item)) {
                                 angular.copy(item, $scope.selectedItem);
                             } else {
                                 angular.copy({}, $scope.selectedItem);
                             }
                         };

                         $scope.isSelect = function(item) {
                             return equals($scope.selectedItem, item);
                         };

                         function isSelected() {
                             return $scope.selectedItem != null && $scope.selectedItem.name != null;
                         }

                         function equals(i1, i2) {
                             if (i1 == null || i2 == null) {
                                 return false;
                             }

                             return ((i1.name === i2.name) && i1.srcCategory != null && (i1.srcCategory.id === i2.srcCategory.id));
                         }

                         $scope.getItems = function() {
                             return $scope.items;
                         };

                         $scope.getValue = $utils.getValue;

                         $scope.showAttachments = function(attachments) {
                             $modal.open({
                                template: require('../../../../../../../view/file-modal-read.html'),
                                controller: 'FileModalReadController',
                                size: 'md',
                                backdrop: false,
                                resolve: {
                                    items: function() {
                                        return attachments;
                                    },
                                },
                            });
                         };
                     }],
    };
}
